import { Type } from '@angular/core';
import { ParserFactory } from '../../services';

import { ParserBase } from '../parser/parser-base';

export abstract class FactoryBase<TModel, TPresenter> {
  private parsers: ParserBase<TModel, TPresenter>[] = [];

  constructor(private parserFac: ParserFactory) {}

  abstract createPresenterModel(model: TModel): TPresenter;
  abstract createDataModel(presenter: TPresenter): TModel;

  getParser(
    modelType: Type<TModel>,
    presenterType: Type<TPresenter>,
    version = 1,
  ): ParserBase<TModel, TPresenter> {
    if (this.parsers[version]) {
      return this.parsers[version];
    } else {
      // load parsers from factory then try to get the proper parser again.
      this.loadParsers(modelType, presenterType);

      if (!this.parsers[version]) {
        throw new Error(
          `No parser registered for <${modelType.name}, ${presenterType.name}> with version: ${version}`,
        );
      }

      return this.parsers[version];
    }
  }

  private loadParsers(
    modelType: Type<TModel>,
    presenterType: Type<TPresenter>,
  ) {
    this.parserFac
      .getParsers(modelType, presenterType)
      .forEach((_parser) => (this.parsers[_parser.version] = _parser));
  }
}
